// extracted by mini-css-extract-plugin
export var redoItem = "_gi-1";
export var redoTrigger = "_gi-0";